module.exports = {
        srcSet: __webpack_public_path__ + "454d3487de0fc94b-600.webp"+" 600w"+","+__webpack_public_path__ + "5c15af87e3c53cab-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "454d3487de0fc94b-600.webp",width: 600,height: 365},{path: __webpack_public_path__ + "5c15af87e3c53cab-1000.webp",width: 1000,height: 609}],
        src: __webpack_public_path__ + "5c15af87e3c53cab-1000.webp",
        toString: function(){return __webpack_public_path__ + "5c15af87e3c53cab-1000.webp"},
        
        width: 1000,
        height: 609
      }